import type {VerticalGroup} from '../models/vertical-group'

/** Returns true if column cannot move left */
export function calculateMoveToLeftDisabled(columnIndex: number, groupByFieldOptions: Array<VerticalGroup>): boolean {
  const firstMoveableColumnIndex = groupByFieldOptions.findIndex(option => option?.groupMetadata?.id)
  return columnIndex <= firstMoveableColumnIndex || firstMoveableColumnIndex === -1
}

/** Returns true if column cannot move right */
export function calculateMoveToRightDisabled(
  columnIndex: number,
  totalColumns: number,
  isSingleSelect: boolean,
): boolean {
  return isSingleSelect && columnIndex === totalColumns - 1
}
